import { render, staticRenderFns } from "./KJT.vue?vue&type=template&id=bc84e808&scoped=true&"
import script from "./KJT.vue?vue&type=script&lang=js&"
export * from "./KJT.vue?vue&type=script&lang=js&"
import style0 from "./KJT.vue?vue&type=style&index=0&id=bc84e808&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc84e808",
  null
  
)

export default component.exports